import React from "react";
import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useDispatch } from "react-redux";
import { clearRecurrenceData } from "../../../redux/slices/lomavisCreator/lomavisCreator";
import { useTranslate } from "@tolgee/react";
import { VIEW_STATUS } from "../config/constants";

const RecurrenceConfirmation = ({
  handleClose,
  handleShow,
  show,
  setCurrentViewDisplayed,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslate();
  return (
    <div>
      <Modal centered show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{t("recurrence.confirmation.header")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{t("recurrence.confirmation.main")}</Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              dispatch(clearRecurrenceData({}));
              setCurrentViewDisplayed(VIEW_STATUS.PLANNING);
              handleClose();
            }}
            variant="secondary"
            size="sm"
          >
            {t("cancel")}
          </Button>
          <Button size="sm" variant="primary" onClick={handleClose}>
            {t("save")}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default RecurrenceConfirmation;
